<template>
  <div>
    <v-row>
      <v-col cols="12" sm="6">
        <v-row no-gutters>
          <v-row align="center" no-gutters>
            <v-icon left>fa-coins</v-icon>
            <span class="title">Total pour cette année</span>
          </v-row>
          <v-row align="center" justify="end" no-gutters>
            <span class="title ml-2">{{ getTotal }}</span>
            <span class="ml-1">$</span>
          </v-row>
        </v-row>
      </v-col>
    </v-row>
    <v-row>
      <v-col
        cols="12"
        sm="4"
        lg="3"
        v-for="item in getOtherYears"
        :key="item.year"
      >
        <v-row
          align="center"
          justify="space-between"
          no-gutters
          class="item-column"
        >
          <v-row align="center" no-gutters>
            <v-icon small left>fa-calendar</v-icon>
            <span class="title">{{ item.year }}</span>
          </v-row>
          <v-row align="center" justify="end" no-gutters>
            <span class="title ml-2">{{ getYearTotal(item) }}</span>
            <span class="ml-1 mr-3">$</span>
            <v-icon
              left
              color="success"
              v-if="getYearDelta(item) > 0 && getTotal > 0"
            >
              fa-chevron-up
            </v-icon>
            <v-icon class="ml-1" color="error" v-else-if="getTotal > 0">
              fa-chevron-down
            </v-icon>
            <span
              v-if="getTotal > 0"
              :style="{
                color: getYearDelta(item) > 0 ? '#149911' : '#DE1A1A'
              }"
              >{{ getYearDelta(item) }}</span
            >
            <span
              v-if="getTotal > 0"
              :style="{
                color: getYearDelta(item) > 0 ? '#149911' : '#DE1A1A'
              }"
              class="ml-1"
              >%</span
            >
          </v-row>
        </v-row>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import moment from "moment";
import { round10 } from "round10";
export default {
  name: "AnalyticEventsSummary",
  props: {
    data: {
      type: Array,
      required: true
    }
  },
  computed: {
    getCurrentYear() {
      return moment().format("YYYY");
    },
    getTotal() {
      const currentYearSales = this.data
        .filter(x => x.year === this.getCurrentYear)
        .map(x => x.sales);
      if (currentYearSales.length > 0) {
        return round10(
          currentYearSales[0]
            .map(x => Number(x.sales))
            .reduce((a, b) => a + b, 0),
          0
        );
      } else {
        return 0;
      }
    },
    getOtherYears() {
      return this.data.filter(x => x.year !== this.getCurrentYear);
    }
  },
  methods: {
    getYearTotal(item) {
      return round10(
        item.sales.map(x => Number(x.sales)).reduce((a, b) => a + b, 0),
        0
      );
    },
    getYearDelta(item) {
      if (this.getTotal > 0) {
        return round10(
          ((this.getTotal - this.getYearTotal(item)) / this.getTotal) * 100,
          0
        );
      } else {
        return undefined;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.item-column {
  border-radius: 4px;
  padding: 0.6rem;
  background-color: rgba(0, 0, 0, 0.06);
}
</style>
